"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_FEATURES = exports.defaultFaqs = void 0;
exports.inheritedSectionFromCreatorLanding = inheritedSectionFromCreatorLanding;
exports.defaultSubscriptionPageConfig = defaultSubscriptionPageConfig;
const helpers_1 = require("./helpers");
const Media_1 = require("./Media");
const zod_1 = require("zod");
const lodash_1 = require("lodash");
const ProgramSchema = zod_1.z.object({
    id: zod_1.z.number(),
    name: zod_1.z.string(),
    description: zod_1.z.string().nullable(),
    mediaCover: Media_1.ImageMedia.nullable(),
    mediaIntro: Media_1.VideoMedia.nullable(),
    influencer: zod_1.z.object({
        bio: zod_1.z.string().nullable(),
        messageProfile: zod_1.z.string().nullable(),
        mediaAvatar: Media_1.ImageMedia,
        customColorSchema: zod_1.z
            .object({
            primaryColor: zod_1.z.string().nullable(),
        })
            .nullable()
            .optional(),
    }),
    faq: zod_1.z
        .array(zod_1.z.object({ question: zod_1.z.string(), answer: zod_1.z.string() }))
        .nullable(),
    testimonials: zod_1.z
        .array(zod_1.z.object({
        name: zod_1.z.string(),
        text: zod_1.z.string(),
        media: zod_1.z.object({
            image: zod_1.z.string().nullable().optional(),
            video: zod_1.z.string().nullable().optional(),
        }),
    }))
        .nullable(),
});
function parseProgramTestimonials(program) {
    if (!program.testimonials)
        return [];
    return program.testimonials.map((testimonial) => {
        return {
            name: testimonial.name,
            text: testimonial.text,
            image: (0, helpers_1.toImgSrc)(testimonial.media),
            video: (0, helpers_1.toVideoSrc)(testimonial.media),
        };
    });
}
exports.defaultFaqs = [
    {
        question: 'What makes Playbook different? How do I know it will work for me?',
        answer: `If you haven’t had success with other workout apps in the past, you may be skeptical about ours. But we’re here to tell you, we guarantee you’ll get the results you want with Playbook. Why? We have hundreds of experts who are ready to train you. We don’t give you one-off programs of PDF documents with no assistance. Our creators add new programs (with interactive, explanatory videos) on a daily basis. Our content is new, fresh, and ever-changing to keep you motivated and ready to work! Plus, if you need help,creators are always here for you. You can message them directly if you have any questions, feedback, or simply want to share your success.`,
    },
    {
        question: "I'm a beginner, is Playbook for me?",
        answer: `No matter where you are in your fitness journey, Playbook can help you succeed. Workouts and programs posted in the app are for any level of fitness. Plus, trainers walk you through all exercises with easy-to-follow videos and simple written instructions. This means you’ll be able to do all the moves easily, accurately, and safely.`,
    },
    {
        question: 'Do I need to purchase equipment?',
        answer: `It depends on the workout! Playbook has a lot of workouts that require no equipment. We also have workouts that require minimal equipment (like dumbbells or a yoga mat) and some that require weight-lifting machines. There’s something for everyone — regardless of equipment — to help you get in shape.`,
    },
];
const ALL_SUB_FEATURES = [
    {
        type: 'reminders',
        name: 'Reminders',
        image: '/images/landing/features/reminders.png',
    },
    {
        type: 'streaks',
        name: 'Streaks',
        image: '/images/landing/features/streaks.png',
    },
    {
        type: 'tracking',
        name: 'Tracking',
        image: '/images/landing/features/tracking.png',
    },
    {
        type: 'favorites',
        name: 'Favorites',
        image: '/images/landing/features/favorites.png',
    },
    {
        type: 'notes',
        name: 'Notes & Logging',
        image: '/images/landing/features/notes.png',
    },
    {
        type: 'stream',
        name: 'Stream Anywhere',
        image: '/images/landing/features/stream.png',
    },
    //   {
    //     type: 'offline',
    //     name: 'Offline Downloads',
    //     image: '/images/landing/features/offline.png',
    //   },
    //   {
    //     type: 'playlist',
    //     name: 'Curated Playlists',
    //     image: '/images/landing/features/playlist.png',
    //   },
    //   {
    //     type: 'nutrition',
    //     name: 'Nutrition',
    //     image: '/images/landing/features/nutrition.png',
    //   },
];
exports.DEFAULT_FEATURES = ALL_SUB_FEATURES.slice(0, 6);
const defaultReviews = [
    {
        name: 'Carrie',
        text: `Love this app!!! Every workout is challenging and I've had amazing results`,
    },
    {
        name: 'Laura',
        text: `Beautiful, user friendly app. truly enjoying having quick access to workouts. makes reaching my goal of daily movement much easier.`,
    },
    {
        name: 'Jess',
        text: `Clear, straightforward, focused workouts that are enjoyable and effective`,
    },
];
function inheritedSectionFromCreatorLanding(landingPageConfig, config) {
    if (!landingPageConfig)
        return {};
    const primaryColor = config.primaryColor;
    const colors = [primaryColor, (0, helpers_1.removeAlpha)(primaryColor, 0.1), '#FFFFFF'];
    function adjustColor(section) {
        const bgColor = colors[section.colorIndex];
        return { ...section, bgColor };
    }
    const INHERITED_SECTIONS = [
        'Bio',
        'Reviews',
        'Testimonials',
        'FAQs',
        'FeaturesNew',
    ];
    const inheritableSections = landingPageConfig?.sections.filter((section) => INHERITED_SECTIONS.includes(section.type));
    const inheritableByType = (0, lodash_1.keyBy)(inheritableSections, 'type');
    const inheritedSections = (0, lodash_1.mapValues)(inheritableByType, adjustColor);
    return inheritedSections;
}
function defaultSubscriptionPageConfig(programUnparsed, config) {
    const program = ProgramSchema.parse(programUnparsed);
    if (!program) {
        throw new Error('Missing expected program data');
    }
    const { mainColor, landingPageConfig } = config;
    const PLAYBOOK_PURPLE_COLOR = '#6367EF';
    const primaryColor = mainColor
        ? mainColor
        : program.influencer.customColorSchema?.primaryColor ||
            PLAYBOOK_PURPLE_COLOR;
    const colors = [primaryColor, (0, helpers_1.removeAlpha)(primaryColor, 0.1), '#FFFFFF'];
    const inheritableByType = inheritedSectionFromCreatorLanding(landingPageConfig, {
        primaryColor,
    });
    return {
        sections: [
            {
                enabled: true,
                type: 'Introduction',
                title: program.name,
                subtitle: 'Get started today!',
                desc: program.description,
                coverImage: (0, helpers_1.toImgSrc)(program.mediaCover),
                introVideo: (0, helpers_1.toVideoSrc)(program.mediaIntro),
                primaryColor,
                logo: '',
                colorIndex: 1,
                bgColor: colors[1],
                priceBefore: null,
            },
            {
                enabled: true,
                type: 'ProgramStats',
                bgColor: colors[2],
                colorIndex: 2,
            },
            {
                enabled: true,
                type: 'Workouts',
                title: 'Workouts',
                bgColor: colors[2],
                colorIndex: 2,
                workoutIds: [],
            },
            inheritableByType['Reviews'] ?? {
                enabled: true,
                type: 'Reviews',
                title: 'Glowing 5-Star Reviews from Satisfied Customers',
                reviews: [...defaultReviews],
                bgColor: colors[1],
                colorIndex: 1,
            },
            inheritableByType['Testimonials'] ?? {
                enabled: true,
                type: 'Testimonials',
                title: 'Need to see it to believe?',
                testimonials: parseProgramTestimonials(program),
                bgColor: colors[0],
                colorIndex: 0,
            },
            inheritableByType['FeaturesNew'] ?? {
                enabled: true,
                type: 'FeaturesNew',
                title: 'Program Features',
                bgColor: colors[1],
                colorIndex: 1,
                features: exports.DEFAULT_FEATURES,
            },
            inheritableByType['Bio'] ?? {
                enabled: true,
                type: 'Bio',
                title: program.influencer.bio || 'Online personal trainer',
                desc: program.influencer.messageProfile,
                coverImage: (0, helpers_1.toImgSrc)(program.influencer.mediaAvatar),
                bgColor: colors[0],
                colorIndex: 0,
                introVideo: null,
            },
            inheritableByType['FAQs'] ?? {
                enabled: true,
                type: 'FAQs',
                title: 'Frequently asked questions',
                faqs: [...(program.faq?.length ? program.faq : exports.defaultFaqs)],
                bgColor: colors[2],
                colorIndex: 2,
            },
        ],
    };
}
